import React,{useEffect} from 'react';

const AboutOurCertifications = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
     <div className="container-fluid" id='our-certifications'>
        <h1>Testimonial & Certification</h1>
        <hr />
        <div className="row first-row">
            <div className="col left-col">
                <img src="img-data/certifications/cert-msme.png" height={600} alt=".." />
                
            </div>
            <div className="col left-col">
                <img src="img-data/certifications/trophy-msme.png" height={600} style={{marginLeft:"-270px"}} alt=".." />
                
            
            </div>
            
            <div className="col right-col">
                <h1>
                    INDIA 5000 <br />
                    BEST MSME <br />
                    A W A R D S
                </h1>
                
                <p>2024 WINNER</p>
            </div>
        </div>
        <div className="row first-row">
            <div className="col left-col">
                <h1>
                    Dealership <br /> Certification
                </h1>
                
                <p>CG Power and Industrial Solutions Limited</p>
            </div>
            <div className="col right-col">
                <img src="img-data/certifications/1.jpg" alt=".." />
            </div>
        </div>
        <div className="row second-row">
            <div className="col left-col">
                <img src="img-data/certifications/2.jpg" alt=".." />
            </div>
            <div className="col right-col">
                <h1>Certificate<br />Of Registration</h1>
                <p>ISO 9001:2015 <br />
                   Quality Management <br />System
                </p>
            </div>
        </div>
        <div className="row third-row">
            <div className="col leftt-col">
            <h1>Certificate<br />Of Registration</h1>
                
            <p>ISO 14001:2015 <br />
                   Environmental <br /> Management System
                </p>
            </div>
            <div className="col right-col">
                <img src="img-data/certifications/3.jpg" alt=".." />
            </div>
        </div>
        <div className="row fourth-row">
            <div className="col left-col">
                <img src="img-data/certifications/4.jpg" alt=".." />
            </div>
            <div className="col right-col">
                <h1>"UDYAM"<br />Registration <br />Certificate</h1>
                <p>Ministry Of <br /> Micro, Small and <br /> Medium Enterprises 
                <br />
                (Government of India)
                </p>
            </div>
        </div>
     </div>
    </>
  )
}

export default AboutOurCertifications
